import { render } from "./sales-order-modal.vue?vue&type=template&id=0fdee8f6&scoped=true"
import script from "./sales-order-modal.vue?vue&type=script&lang=js"
export * from "./sales-order-modal.vue?vue&type=script&lang=js"

import "./sales-order-modal.vue?vue&type=style&index=0&id=0fdee8f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdee8f6"]])

export default __exports__